import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import { IOverlayData, IWinData, OverlayType } from "../../../vendor_core/core/src/server/data/ISpinData";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import SymbolAnimation from "../../../vendor_core/core/src/views/SymbolAnimation";
import WinSymbolsView from "../../../vendor_core/core/src/views/WinSymbolsView";
import GameSoundVars from "../enums/GameSoundVars";

export default class VOEWinSymbolsView extends WinSymbolsView {

    private prevSymbolPosition: number[][];

    public create(
        scene: SceneView,
        extraSymbols: number,
        winSymbolsLayer?: string
    ) {
        super.create(scene, extraSymbols, winSymbolsLayer);
    }

    public playWinLineSymbols(
        winLineData: IWinData,
        ids: number[]
    ): Promise<boolean> {
        this.scene.containers.get("wins").enableMask();
        return super.playWinLineSymbols(winLineData, ids);
    }

    public hideWinlineWinSymbols(winLineData: IWinData) {
        const winSyms = this.getWinlineWinSymbols(winLineData);
        winSyms.forEach((symbol) => {
            if (symbol.id !== 15) {
                symbol.hideWin()
            }
        });
    }

    public lockSymbols(overlay: IOverlayData, lockAnim?: string): Promise<boolean> {
        lockAnim = "lock_chain";
        return new Promise((res) => {
            let counter = 0;
            overlay.symbolPosition.forEach((reel, reelId) => {
                reel.forEach((sym, rowId) => {
                    let symId = rowId;
                    if (this.config.symbolIds.indexOf(sym) >= 0) {
                        let anim = this.getAnimAtReelCell(reelId, symId);
                        counter++;
                        if (lockAnim) {
                            if (this.prevSymbolPosition.length && this.prevSymbolPosition[reelId][symId] !== null) {
                                counter--;
                                if (counter <= 0) {
                                    res();
                                }
                            } else {
                                SoundController.playSound(GameSoundVars.BN2_STICKY_WILD_LAND, false, undefined, false);
                                anim.showAnim(sym, lockAnim).then(() => {
                                    counter--;
                                    if (counter <= 0) {
                                        res();
                                    }
                                });
                            }
                        } else {
                            counter--;
                            // anim.showStatic(sym);
                        }
                        anim.isLocked = true;
                    } else if (
                        this.reelSymMap &&
                        this.reelSymMap.has(this.generateReelKey(reelId, symId))
                    ) {
                        let animToUnlock = this.reelSymMap.get(
                            this.generateReelKey(reelId, symId)
                        );
                        animToUnlock.isLocked = false;
                        this.returnToPosition(reelId, rowId);
                    }

                    if (counter <= 0) {
                        res();
                    }
                });
            });
            this.prevSymbolPosition = overlay.symbolPosition;
        });
    }

    public unlockAll(isException?: (anim: SymbolAnimation, reelIdx?: {reel:number, row: number}) => boolean) {
        this.prevSymbolPosition = [];
        super.unlockAll(isException);
    }
}
